import * as React from "react";

var ItemAsegurado = function ItemAsegurado(props) {
  var itemAsegurado = props.itemAsegurado;
  return /*#__PURE__*/React.createElement("tbody", {
    className: "table-bordered"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Marca:"), /*#__PURE__*/React.createElement("td", null, (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.brand) || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Patente:"), /*#__PURE__*/React.createElement("td", null, (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.patente) || "-")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Materia Asegurada:"), /*#__PURE__*/React.createElement("td", null, (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.materia_asegurada) || "-"), /*#__PURE__*/React.createElement("th", {
    scope: "row"
  }, "Comentarios adicionales:"), /*#__PURE__*/React.createElement("td", null, (itemAsegurado === null || itemAsegurado === void 0 ? void 0 : itemAsegurado.comments) || "-")), /*#__PURE__*/React.createElement("tr", null));
};

export default ItemAsegurado;